import { Pipe, PipeTransform } from '@angular/core';
import { DateFilterService } from '../../services/filter/date-filter-service';

@Pipe({
  name: 'utcDate',
  standalone: true,
})
export class UtcDatePipe implements PipeTransform {
  private _dateFilterService: DateFilterService;

  constructor(dateFilterService: DateFilterService) {
    this._dateFilterService = dateFilterService;
  }

  transform(value: string | null | undefined | unknown): string {
    if (!value) {
      return '';
    } else if (typeof value === 'string')
      return this._dateFilterService.convertUtcDate(value);
    else {
      throw new Error('UtcDatePipe: Invalid value type');
    }
  }
}
